import React from 'react';
import { Pagination } from 'react-bootstrap';

const NextPrevPagination = ({ currentPage, totalPages, onPrev, onNext }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="d-flex justify-content-center mt-4">
      <Pagination>
        <Pagination.Item onClick={onPrev} disabled={currentPage === 1}>
          Prev
        </Pagination.Item>
        <span className="align-self-center mx-3 text-white fw-semibold">
          Page {currentPage} of {totalPages}
        </span>
        <Pagination.Item
          onClick={onNext}
          disabled={currentPage === totalPages}
          className="ms-2"
        >
          Next
        </Pagination.Item>
      </Pagination>
    </div>
  );
};

export default NextPrevPagination;
